






































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const loginerModule = namespace('loginer')
const TRANSFOR_KEY: any = ['title', 'entname']
@Component
export default class Notify extends Vue {
	@loginerModule.Mutation('SET_LOGINER') private setLoginer!: any
	private orderData: any = {}
	private unReadCount: number = 0
	private searchKey: string = ''
	private get tableData () {
		return this.transforDetails(this.orderData.data)
	}
	private created () {
		this.refreshNotifyList()
	}
	private refreshNotifyList () {
		this.getNotifyListData()
	}
	private getNotifyListData () {
		return (this as any).$fxHttp.requestGet({
			url: '/announcement/list',
			fullData: true
		}).then((res: any) => {
			this.orderData = res
			this.unReadCount = res.otherdata.unReadAnnoCount
			this.setLoginer({
				loginerNotifyNumber: res.otherdata.unReadAnnoCount || ''
			})
		})
	}
	private transforDetails (goodDetails: any = []) {
		return goodDetails.filter((item: any) => {
			return (this as any).$fxUtils.fuzzyQueryObj(item, this.searchKey.trim(), TRANSFOR_KEY)
		})
	}
	private onRowClick (item: any): void {
		this.$router.push({
			path: 'notifyDetails',
			query: {
				id: item.id
			}
		})
	}
	private doReadAll () {
		return (this as any).$fxHttp.requestGet({
			url: '/announcement/readall'
		}).then((res: any) => {
			this.tableData.forEach((item: any) => {
				item.readtag = '1'
			})
		})
	}
}
